<div class="sidebar">
    <aside class="widget-area">

        <!-- ── Recherche ─────────────────────────────────────────────── -->
        <div class="sidebar__single sidebar__single--search">
            <form (ngSubmit)="onSearch()" class="sidebar__search">
                <input type="text"
                       [(ngModel)]="searchQuery"
                       name="searchQuery"
                       [placeholder]="'sidebar_recherche_ph' | translate" />
                <button type="submit" aria-label="search submit">
                    <span><i class="icon-magnifying-glass"></i></span>
                </button>
            </form>
        </div>

        <!-- ── Catégories ────────────────────────────────────────────── -->
        <div class="sidebar__single">
            <h4 class="sidebar__title">{{ 'sidebar_categories' | translate }}</h4>
            <ul class="sidebar__categories list-unstyled" *ngIf="!loadingCats; else catLoader">
                <li *ngFor="let cat of categories">
                    <a (click)="filterByCategory(cat.id)" style="cursor:pointer">
                        {{ translateField(cat.name) }}
                    </a>
                </li>
                <li *ngIf="categories.length === 0" class="sidebar__empty">
                    {{ 'sidebar_aucune_categorie' | translate }}
                </li>
            </ul>
            <ng-template #catLoader>
                <ul class="sidebar__categories list-unstyled">
                    <li class="sidebar__skeleton" *ngFor="let i of [1,2,3,4]"></li>
                </ul>
            </ng-template>
        </div>

        <!-- ── Articles récents ──────────────────────────────────────── -->
        <div class="sidebar__single">
            <h4 class="sidebar__title">{{ 'sidebar_recents' | translate }}</h4>
            <ul class="sidebar__posts list-unstyled" *ngIf="!loadingPosts; else postsLoader">
                <li class="sidebar__posts__item" *ngFor="let post of recentPosts">
                    <div class="sidebar__posts__image">
                        <img [src]="getFeaturedImage(post)" [alt]="translateField(post.title)">
                    </div>
                    <div class="sidebar__posts__content">
                        <p class="sidebar__posts__meta">
                            <i class="icofont-calendar"></i>
                            {{ post.created_at | localDate:'fr' }}
                        </p>
                        <h4 class="sidebar__posts__title">
                            <a [routerLink]="['/articles', post.slug]">
                                {{ translateField(post.title) | slice:0:55 }}{{ (translateField(post.title).length > 55) ? '…' : '' }}
                            </a>
                        </h4>
                    </div>
                </li>
                <li *ngIf="recentPosts.length === 0" class="sidebar__empty">
                    {{ 'sidebar_aucun_article' | translate }}
                </li>
            </ul>
            <ng-template #postsLoader>
                <ul class="sidebar__posts list-unstyled">
                    <li class="sidebar__posts__item sidebar__skeleton--post" *ngFor="let i of [1,2,3]">
                        <div class="sidebar__posts__image sidebar__skeleton"></div>
                        <div class="sidebar__posts__content">
                            <div class="sidebar__skeleton" style="height:10px;width:60%;margin-bottom:6px"></div>
                            <div class="sidebar__skeleton" style="height:12px;width:90%"></div>
                        </div>
                    </li>
                </ul>
            </ng-template>
        </div>

        <!-- ── Lien galerie ──────────────────────────────────────────── -->
        <div class="sidebar__single sidebar__single--gallery">
            <a [routerLink]="['/galerie']" class="sidebar__gallery-link">
                <i class="icofont-image"></i>
                {{ 'sidebar_voir_galerie' | translate }}
                <span class="icofont-double-right"></span>
            </a>
        </div>

    </aside>
</div>
